import { Breakfast, TimeOut } from "components/assets/Icons";
import UserInfo from "components/UserInfo";
import { useEffect, useRef, useState } from "react";
import userService from "services/user.service";
import getDayName, { padTo2Digits } from "utils/modifyDate";
import Popup from "../Popup";
import styles from "./Table.module.scss";

const Table = ({ workingHoursReport = [], photos, sortColumn }) => {
  const ref = useRef("");
  const popupRef = useRef("");
  const cellRef = useRef([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({});
  const [popupWidth, setPopupWidth] = useState(0);
  const [activeColumn, setActiveColumn] = useState("first_name");

  function setHeaderHeight() {
    if (typeof window === "object") {
      return document.documentElement.style.setProperty(
        "--thead-height",
        `${ref.current?.offsetHeight}px`
      );
    }
  }

  useEffect(() => {
    setHeaderHeight();
  }, [workingHoursReport]);

  const handleClickColumn = (columnName) => {
    sortColumn(columnName);
    setActiveColumn(columnName);
  };

  useEffect(() => {
    showPopup && setPopupWidth(popupRef?.current.offsetWidth);
  }, [showPopup]);

  const handleClickCell = (
    e,
    id,
    firstName,
    lastName,
    photo,
    date,
    breaksViolation,
    scheduleEndViolation,
    scheduleStartViolation
  ) => {
    // eslint-disable-next-line no-useless-escape
    const newDateString = date?.replace(/T[0-9\:\-]*/g, "");
    const rect = e?.target.getBoundingClientRect();

    userService
      .getPopupData("working_hours/popup_data/", newDateString, id)
      .then(
        (response) => {
          const allData = Object.assign(
            response?.data?.data,
            {
              firstName,
              lastName,
              photo,
              date,
              breaksViolation,
              scheduleEndViolation,
              scheduleStartViolation,
            },
            {
              position: {
                x:
                  rect?.left < window?.outerWidth - popupWidth ? rect?.left : 0,
                y: rect?.top,
              },
            }
          );
          setPopupData(allData);
          setShowPopup(true);
        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          setPopupData(_content);
        }
      );
  };

  const formatDate = (date) => {
    const dateInfo = new Date(date);
    const day = padTo2Digits(dateInfo.getDate());
    const dayName = getDayName(dateInfo);

    return `${dayName}, ${day}`;
  };

  return (
    <>
      {workingHoursReport && (
        <div
          className={styles.wrapper}
          style={{ overflow: showPopup ? "hidden" : "scroll" }}
        >
          <table className={styles.content}>
            <thead className={styles.header} ref={ref}>
              <tr className={styles.row}>
                <th
                  onClick={() => handleClickColumn("first_name")}
                  className={activeColumn === "first_name" ? styles.active : ""}
                >
                  Name
                </th>
                {workingHoursReport[0]?.data?.map(({ date }, index) => {
                  return <th key={index}>{formatDate(date)}</th>;
                })}
                <th
                  onClick={() => handleClickColumn("total_duration")}
                  className={
                    activeColumn === "total_duration" ? styles.active : ""
                  }
                >
                  Total, h
                </th>
              </tr>
            </thead>
            <tbody className={styles.body}>
              {workingHoursReport?.map(
                (
                  { id, first_name, last_name, data, total_duration },
                  index
                ) => {
                  return (
                    <tr key={last_name + index}>
                      <td>
                        <UserInfo
                          src={photos[id]}
                          name={first_name + " " + last_name}
                        />
                      </td>
                      {data?.map(
                        (
                          {
                            date,
                            duration,
                            breaks_violation,
                            schedule_end_violation,
                            schedule_start_violation,
                          },
                          index
                        ) => {
                          return (
                            <td
                              key={duration + index}
                              className={
                                breaks_violation ||
                                schedule_end_violation ||
                                schedule_start_violation
                                  ? styles.error
                                  : ""
                              }
                              ref={(element) => {
                                cellRef.current[index] = element;
                              }}
                              onClick={(e) =>
                                handleClickCell(
                                  e,
                                  id,
                                  first_name,
                                  last_name,
                                  photos[id],
                                  date,
                                  breaks_violation,
                                  schedule_end_violation,
                                  schedule_start_violation
                                )
                              }
                            >
                              {duration ?? "0:00"}
                              {(schedule_end_violation ||
                                schedule_start_violation) && <TimeOut />}
                              {breaks_violation && <Breakfast />}
                            </td>
                          );
                        }
                      )}
                      <td>{total_duration}</td>
                    </tr>
                  );
                }
              )}
            </tbody>
          </table>
        </div>
      )}

      {showPopup && (
        <Popup data={popupData} setShowPopup={setShowPopup} ref={popupRef} />
      )}
    </>
  );
};

export default Table;
